module.exports = __webpack_public_path__ + "static/media/3x3 minus row.fe72fc6f.jpg";